import React from 'react';
import { TKlarityProgramItem } from 'types/common';
import { getKlarityProgramList } from 'api/common';
import { getOpsProviderKlarityProgramList } from 'api/operation';
import { message } from 'antd';

let globalData: TKlarityProgramItem[] = [];

const useKlarityProgram = (isOps?: boolean, providerId?: number): [TKlarityProgramItem[], boolean, () => void] => {
    const [loading, setLoading] = React.useState(false);
    const [items, setItems] = React.useState<TKlarityProgramItem[]>(globalData);
    const fetchData = async () => {
        if (loading) return;
        try {
            setLoading(true);
            let result: any;
            if (isOps) {
                if (providerId) {
                    result = await getOpsProviderKlarityProgramList(providerId);
                } else {
                    const errorMsg = 'Provider ID is required';
                    message.error(errorMsg);
                }
            } else {
                result = await getKlarityProgramList();
            }
            if (!result.error) {
                const resData = result?.data?.data || [];
                globalData = resData;
                setItems(resData);
            }
            // setLoading(false);
        } catch (e) {
            console.error(e);
        }
        setLoading(false);
    };
    React.useEffect(() => {
        fetchData();
    }, []);

    return [items, loading, fetchData];
};

export default useKlarityProgram;
